---
title: Your licence key
lede: One key that never changes, kept in the OS keychain and checked by the licence service.
order: 3
part: Get started
---

Airlock is a subscription with one licence key. The key never changes when you renew; the subscription decides how long it unlocks the app and its updates. Manage it in **Settings › License**.

![The licence page](media/settings-license.webp)

### Add your key

- **Sign in** (under *Your key from your account*): your browser opens on your account, and you approve the short code the page shows. The computer receives its key; your password never reaches the app.
- **Store**: paste the key from your invoice into **License key**. Case, spaces and hyphens do not matter.

### What the page shows

| Row | What it means |
|---|---|
| Trial | Days left in the 14-day trial, or the day it ended. Shown until you store a key of your own |
| Machine | This computer's short id |
| Key | The stored key, masked. During the trial, this is the trial's own key |
| Tier | What the key is licensed as, such as `personal` |
| Key expiry | The date the key itself carries. A bought key says `never`, so read **Access until** |
| Access until | The last day your subscription covers |
| Serial | The key's serial number |
| Machines | Machines in use out of those the key allows. **Manage ↗** opens your account, where you can remove one |
| Last check | Whether the licence service accepted the key, and when. **Check** asks again |

A key covers two machines. A machine not seen for a month frees its slot by itself.

### When access ends

When the trial ends, the subscription lapses, this computer is one too many, your organization stops paying for its seats, or it cut this computer off, a screen covers the window. It offers the fix that fits: buy or renew, sign in, paste a key, or **Check again** after renewing or freeing a slot. No new session or task starts, and your sessions keep running behind it.

### Forget the key

**Forget** removes the key from the keychain. This install stops getting updates until you store a key again.

### Your organization

If you hold a seat in an organization, the page also shows **Your account**, with **Join** for the workspaces it shares and **Open the account page ↗**, and an **Encryption** group for each organization. See [Your organization's workspaces](/organization).
